import Cill from "./cill/Cill";
import ExternalDoorColour from "./door-colour/ExternalDoorColour";
import InternalDoorColour from "./door-colour/InternalDoorColour";

import DoorStyle from "./door style/DoorStyle";

import OpeningDirection from "./opening-direction/OpeningDirection";
import SpyHole from "./spy-hole/SpyHole";

import DoorDimensions from "./dimensions/DoorDimensions";
import EKey from "./e-key/EKey";
import Escutcheon from "./escutcheon/Escutcheon";
import FrameExtender from "./frame-extender/FrameExtender";
import GlassOptions from "./glass-options/GlassOptions";
import HandleStyle from "./handle-style/HandleStyle";
import Hinge from "./hinge/Hinge";
import HouseNumber from "./house-number/HouseNumber";
import InternalHandleStyle from "./handle-style/InternalHandleStyle";
import Type from "./type/Type";
import OxideRange from "./oxide/oxide";
import ApertureDimensions from "./panel/ApertureDimensions";

export const componentMapping = {
    DoorDimensions,
    DoorStyle,
    ExternalDoorColour,
    InternalDoorColour,
    HandleStyle,
    OpeningDirection,
    GlassOptions,
    Type,
    HouseNumber,
    Cill,
    SpyHole,
    EKey,
    Escutcheon,
    FrameExtender,
    InternalHandleStyle,
    Hinge,
    OxideRange,
    ApertureDimensions
};
